import { Stack, Label, TextField, ComboBox, IComboBoxOption, PrimaryButton, DefaultButton, IContextualMenuItem, DetailsList, DetailsListLayoutMode, SelectionMode, ISelection } from '@fluentui/react';
import React from 'react';
import styles from '../styles/pokemon.module.scss';
import { TProduct, TSet } from '../constants/types';
import { CreateSetMenu } from '../services/Globals';

export interface IProductsProps {
    dev: boolean;
    sets: TSet[];
    ShowMessage: Function;
    apiUrl: string;
    token: string;
    username: string;
    site: string;
}

export interface IProductsState {
    title: string;
    description: string;
    type: string;
    priceineur: string;
    available: string;
    tags: string;
    files: FileList;
    setid: number;
    setsMenu: IContextualMenuItem[];
    products: TProduct[];
    selection: ISelection;
    selectedIndex: number;
    imageNames: string;
    order: string;
};

const typeOptions: IComboBoxOption[] = [
    { key: 'Misc', text: 'Misc' },
    { key: 'Collection', text: 'Collection' },
    { key: 'Booster', text: 'Booster' },
];

export default class Products extends React.Component<IProductsProps, IProductsState> {
    constructor(props: IProductsProps) {
        super(props);
        this.state = {
            products: [],
            title: "",
            description: "",
            type: "",
            priceineur: "",
            available: "",
            tags: "",
            setid: 208,
            files: null,
            selection: null,
            selectedIndex: -1,
            order: "1",
            imageNames: "",
            setsMenu: CreateSetMenu(props.sets, 208, this.onSelectedSet, this.onSelectedSet)
        };
        this.GetProducts();
    }

    componentDidUpdate(prevProps: Readonly<IProductsProps>, prevState: Readonly<IProductsState>, snapshot?: any): void {
        if (prevProps.sets != this.props.sets) {
            this.setState({ setsMenu: CreateSetMenu(this.props.sets, this.state.setid, this.onSelectedSet, this.onSelectedSet) });
        }
    }

    GetProducts = (): Promise<TProduct[]> => {
        return new Promise((resolve, reject) => {
            fetch(`${this.props.apiUrl}/Products?username=${this.props.username}&token=${this.props.token}&site=${this.props.site}`, {
                method: 'GET',
                mode: 'cors',
            }).then((response) => response.json()).then((data: TProduct[]) => {
                this.setState({ products: data });
            });
        });
    }

    Submit = () => {
        let formData = new FormData();
        for (let i = 0; i < this.state.files?.length; i++) {
            formData.append(this.state.files[i].name, this.state.files[i]);
        }

        formData.append("Title", this.state.title);
        formData.append("Description", this.state.description);
        formData.append("Type", this.state.type);
        formData.append("PriceInEUR", this.state.priceineur);
        formData.append("Tags", this.state.tags);
        formData.append("Available", this.state.available);
        formData.append("Order", this.state.order);
        formData.append("SetID", this.state.setid.toString());

        console.log(formData);

        fetch(`${this.props.apiUrl}/addProduct?username=${this.props.username}&token=${this.props.token}&site=${this.props.site}`, {
            method: "Put",
            mode: "cors",
            referrerPolicy: "origin-when-cross-origin",
            body: formData
        }).then((response) => response.json()).then((data: boolean) => {
            if (data) {
                this.props.ShowMessage("Product added");
                this.setState({
                    title: "",
                    description: "",
                    type: "",
                    priceineur: "",
                    available: "",
                    setid: -1,
                    tags: "",
                    imageNames: "",
                    order: "1",
                    files: null
                });
                this.GetProducts();
            } else {
                alert("Something went wrong in backend");
            }
        }).catch(err => {
            alert(err);
        });
    }

    onSelectedSet = (setid: number) => {
        this.setState({ setid: setid });
    }

    selected = () => {
        const prod = this.state.products[this.state.selectedIndex];
        this.setState({
            title: prod.title,
            description: prod.description,
            type: prod.type,
            priceineur: prod.priceInEUR?.toString(),
            available: prod.available?.toString(),
            setid: prod.setID,
            tags: prod.tags,
            imageNames: prod.imageNames,
            order: prod.order?.toString()
        });
    }

    update = () => {
        let formData = new FormData();
        for (let i = 0; i < this.state.files?.length; i++) {
            formData.append(this.state.files[i].name, this.state.files[i]);
        }

        formData.append("Title", this.state.title);
        formData.append("Description", this.state.description);
        formData.append("Type", this.state.type);
        formData.append("PriceInEUR", this.state.priceineur);
        formData.append("Tags", this.state.tags);
        formData.append("Available", this.state.available);
        formData.append("SetID", this.state.setid.toString());
        formData.append("Order", this.state.order);
        formData.append("Id", this.state.products[this.state.selectedIndex].id.toString());
        formData.append("token", this.props.token);
        formData.append("username", this.props.username);

        console.log(formData);

        fetch(`${this.props.apiUrl}/updateProduct?username=${this.props.username}&token=${this.props.token}&site=${this.props.site}`, {
            method: "Put",
            mode: "cors",
            referrerPolicy: "origin-when-cross-origin",
            body: formData
        }).then((response) => response.json()).then((data: boolean) => {
            if (data) {
                this.props.ShowMessage("Product updated");
                this.setState({
                    title: "",
                    description: "",
                    type: "",
                    priceineur: "",
                    available: "",
                    setid: -1,
                    tags: "",
                    imageNames: "",
                    order: "1",
                    selection: null
                });
                this.GetProducts();
            } else {
                alert("Something went wrong in backend");
            }
        }).catch(err => {
            alert(err);
        });
    }

    Test = () => {
        this.props.ShowMessage("test");
    }

    public render(): React.ReactElement<IProductsProps> {
        console.log(this.state);
        return (
            <div>
                <DetailsList
                    items={this.state.products}
                    isHeaderVisible={true}
                    selectionMode={SelectionMode.single}
                    selection={this.state.selection}
                    onActiveItemChanged={(item?: any, index?: number, ev?: React.FocusEvent<HTMLElement, Element>) => {
                        this.setState({selection: item, selectedIndex: index}, this.selected);
                    }}
                />
                <div className={styles.divTable}>
                    <div className={styles.divTableRow}>
                        <div className={styles.divTableCellSmall}>
                            <Label>Title</Label>
                        </div>
                        <div className={styles.divTableCell}>
                            <TextField placeholder='151 booster pack' value={this.state.title} onChange={(e, v) => { this.setState({ title: v }) }} />
                        </div>
                        <div className={styles.divTableCellSmallWide}>
                        </div>
                    </div>
                    <div className={styles.divTableRow}>
                        <div className={styles.divTableCellSmall}>
                            <Label>Description</Label>
                        </div>
                        <div className={styles.divTableCell}>
                            <TextField value={this.state.description} placeholder='SV: 151 booster pack. Deze bevat 10 kaarten.' onChange={(e, v) => { this.setState({ description: v }) }} />
                        </div>
                        <div className={styles.divTableCellSmallWide}>
                        </div>
                    </div>
                    <div className={styles.divTableRow}>
                        <div className={styles.divTableCellSmall}>
                            <Label>Type</Label>
                        </div>
                        <div className={styles.divTableCell}>
                            <ComboBox selectedKey={this.state.type} placeholder='MISC' options={typeOptions} onChange={(e, o) => { this.setState({ type: o.text }); }} />
                        </div>
                        <div className={styles.divTableCellSmallWide}>
                        </div>
                    </div>
                    <div className={styles.divTableRow}>
                        <div className={styles.divTableCellSmall}>
                            <Label>Price in EUR</Label>
                        </div>
                        <div className={styles.divTableCell}>
                            <TextField value={this.state.priceineur} placeholder='1.99' type='number' onChange={(e, v) => { this.setState({ priceineur: v }) }} />
                        </div>
                        <div className={styles.divTableCellSmallWide}>
                        </div>
                    </div>
                    <div className={styles.divTableRow}>
                        <div className={styles.divTableCellSmall}>
                            <Label>Tags</Label>
                        </div>
                        <div className={styles.divTableCell}>
                            <TextField value={this.state.tags} placeholder='Set:Scarlet & Violet|Boosterpacks:9|Sleeves:65|Energie kaarten:45' onChange={(e, v) => { this.setState({ tags: v }) }} />
                        </div>
                        <div className={styles.divTableCellSmallWide}>
                        </div>
                    </div>
                    <div className={styles.divTableRow}>
                        <div className={styles.divTableCellSmall}>
                            <Label>Images</Label>
                        </div>
                        <div className={styles.divTableCell}>
                            <Label>{this.state.imageNames}</Label>
                            <input accept="image/*" type="file" id="files" name="files" multiple onChange={(e) => { this.setState({ files: e.target.files }); }} />
                        </div>
                        <div className={styles.divTableCellSmallWide}>
                        </div>
                    </div>
                    <div className={styles.divTableRow}>
                        <div className={styles.divTableCellSmall}>
                            <Label>Order</Label>
                        </div>
                        <div className={styles.divTableCell}>
                            <TextField value={this.state.order} placeholder='1' type='number' onChange={(e, v) => { this.setState({ order: v }) }} />
                        </div>
                        <div className={styles.divTableCellSmallWide}>
                        </div>
                    </div>
                    <div className={styles.divTableRow}>
                        <div className={styles.divTableCellSmall}>
                            <Label># Available</Label>
                        </div>
                        <div className={styles.divTableCell}>
                            <TextField value={this.state.available} placeholder="1" type='number' onChange={(e, v) => { this.setState({ available: v }) }} />
                        </div>
                        <div className={styles.divTableCellSmallWide}>
                        </div>
                    </div>
                    <div className={styles.divTableRow}>
                        <div className={styles.divTableCellSmall}>
                            <Label>Set</Label>
                        </div>
                        <div className={styles.divTableCell}>
                            <DefaultButton className={styles.setSelector} text={this.props.sets.find(set => set.id == this.state.setid)?.name} menuProps={{ items: this.state.setsMenu, shouldFocusOnMount: true, subMenuHoverDelay: 250 }} />
                        </div>
                        <div className={styles.divTableCellSmallWide}>
                        </div>
                    </div>
                    <Stack horizontal>
                        <PrimaryButton text='Submit' onClick={this.Submit} />
                        &nbsp;
                        <PrimaryButton disabled={this.state.selection == null ? true : false} text='Update' onClick={this.update} />
                        &nbsp;
                        {/* <PrimaryButton text='Test' onClick={this.Test} /> */}
                        
                    </Stack>
                </div>
            </div>
        );
    }
}